import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, DataTable, SubHeading } from "../Components";
import { postAxios } from "../Services/commonService";
import {
  API_ALL_KITE_EXCHANGE_IMPORT,
  API_ALL_KITE_EXCHANGE_LIST,
} from "../utils/api/ApiConstant";
import { useLocation } from "react-router-dom";

const ImportFilterList = () => {
  const location = useLocation();
  const { exchange } = location.state || {};
  const queryClient = useQueryClient();
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [dateArray, setDateArray] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [isHideBtn, setIsHideBtn] = useState(true);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const {
    isLoading,
    data: exchangeData,
    refetch,
  } = useQuery({
    queryKey: [
      "exchangeData",
      searchTerm,
      exchange,
      currentPage,
      recordsPerPage,
      selectedDates,
    ],
    queryFn: async () =>
      await postAxios({
        url: API_ALL_KITE_EXCHANGE_LIST,
        payload: {
          exchange,
          dateArray: selectedDates,
          page: currentPage,
          limit: recordsPerPage,
          search: searchTerm,
        },
      }),
  });

  // Initialize dateArray from API
  useEffect(() => {
    if (exchangeData?.dateFilter && dateArray.length == 0) {
      setDateArray(
        exchangeData.dateFilter.map((d) => ({ date: d, isChecked: false }))
      );
    }
  }, [exchangeData]);

  const handleImport = async () => {
    if (selectedIds?.length > 0) {
      const payload = { ids: selectedIds, exchange: exchange };

      const res = await postAxios({
        url: API_ALL_KITE_EXCHANGE_IMPORT,
        payload,
      });

      if (res) {
        handleSelectionChange([]);
        refetch();
      }
    }
  };

  const filteredData = useMemo(() => {
    let arr = [];
    const selectedDates = dateArray
      .filter((d) => d.isChecked)
      .map((d) => {
        arr.push(d.date);
        return d.date;
      });

    setSelectedDates(arr);
    // if (selectedDates.length > 0) {
    // return exchangeData.responsedata.filter((item) =>
    //   selectedDates.includes(item.expiry)
    // );
    // }
    if (!exchangeData?.responsedata) return [];

    if (!isHideBtn) return []; // hide all
    return exchangeData?.responsedata;
  }, [exchangeData, dateArray, isHideBtn]);

  const handleSearch = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  const handleSelectionChange = useCallback((selected) => {
    setSelectedIds(selected);
  }, []);

  const handleDateChange = useCallback((index, checked) => {
    setDateArray((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, isChecked: checked } : item
      )
    );
    setCurrentPage(1);
  }, []);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleRecordsperPage = useCallback((value) => {
    setRecordsPerPage(value);
  }, []);

  const columns = useMemo(
    () => [
      { accessorKey: "name", header: "Name" },
      { accessorKey: "expiry", header: "Expiry" },
      { accessorKey: "exchange_token", header: "Exch Token" },
      { accessorKey: "instrument_token", header: "Inst. Token" },
      { accessorKey: "tradingsymbol", header: "Trading Symbol" },
      { accessorKey: "strike", header: "Strike" },
      { accessorKey: "instrument_type", header: "Instrument Type" },
    ],
    []
  );

  const fetchData = useCallback(() => {
    if (!exchangeData) return { data: [], pages: 0 };
    return { data: filteredData, pages: exchangeData?.totalPages };
  }, [exchangeData, filteredData]);

  const formatDate = (date, format = "dd-mm-yyyy") => {
    if (!date) return "";
    const d = new Date(date);

    if (isNaN(d)) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    switch (format) {
      case "yyyy-mm-dd":
        return `${year}-${month}-${day}`;
      case "mm-dd-yyyy":
        return `${month}-${day}-${year}`;
      default: // dd-mm-yyyy
        return `${day}-${month}-${year}`;
    }
  };
  return (
    <>
      <SubHeading
        subTitle={`Filter kite Exchange : ${exchange}`}
        isAddBtn={false}
      />
      <hr style={{ backgroundColor: "white", margin: "0.5px" }} />

      <div className="my-2 px-2">
        {!isHideBtn ? (
          <Button
            className="btn-success mx-1"
            onClick={() => setIsHideBtn(true)}
          >
            Show All
          </Button>
        ) : (
          <Button
            className="btn-danger mx-1"
            onClick={() => setIsHideBtn(false)}
          >
            Hide All
          </Button>
        )}
        <Button className="btn-success mx-1" onClick={handleImport}>
          Import
        </Button>
      </div>

      <div className="d-flex align-items-center flex-wrap gap-3 px-2 pb-3">
        {dateArray.map((value, index) => (
          <div key={index} className="d-flex align-items-center">
            <input
              type="checkbox"
              id={`date-${index}`}
              className="m-1 cursor-pointer"
              style={{ transform: "scale(1.4)" }}
              checked={value.isChecked}
              onChange={(e) => handleDateChange(index, e.target.checked)}
            />
            <label htmlFor={`date-${index}`} className="cursor-pointer">
              {formatDate(value.date)}
            </label>
          </div>
        ))}
      </div>

      <div className="card-body">
        <DataTable
          columns={columns}
          fetchData={fetchData}
          onSearchChange={handleSearch}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onRecordsPerPageChange={handleRecordsperPage}
          recordsPerPage={recordsPerPage}
          isLoading={isLoading}
          isIndexing={false}
          isSearchable={true}
          isPageSize={true}
          isCheckBox={true}
          isPagination={true}
          onSelectionChange={handleSelectionChange}
          handleSearchKey={setIsShow}
        />
      </div>
    </>
  );
};

export default ImportFilterList;
